import gameNames from 'a/hub/data/GameIds';
import { ACTION_TYPES } from 'a/mindTheGap/data/constants';

const initialState = {
  isOnboarding: true,
  hasSelectedOnboardingAnswer: false,
  isUserSelectionEnabled: true,
  selectedPlaceholder: '{-1}',
  selectedSectionIndex: -1,
  answersMap: {},
};

const sessionReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== gameNames.MIND_THE_GAP) {
    return state;
  }

  switch (type) {
    case ACTION_TYPES.INIT_SESSION:
      return {
        ...initialState,
        isOnboarding: true,
      };
    case ACTION_TYPES.FETCH_CURRICULUM_START:
      return {
        ...initialState,
        isOnboarding: state.isOnboarding,
      };
    case ACTION_TYPES.SET_FIRST_PLACEHOLDER: {
      return {
        ...state,
        firstPlaceholder: payload,
      };
    }
    case ACTION_TYPES.LOAD_SAVED_DATA:
      return {
        ...state,
        ...payload,
      };
    case ACTION_TYPES.SELECT_AN_ANSWER: {
      const answersMap = { ...state.answersMap };
      const { key, answer, correctAnswer, isCorrect, possibleAnswers, previousSelection } = payload;
      answersMap[key] = {
        selection: answer,
        correctSelection: correctAnswer,
        isCorrect,
        possibleAnswers,
        previousSelection,
      };

      return {
        ...state,
        answersMap,
        hasSelectedOnboardingAnswer: true,
      };
    }
    case ACTION_TYPES.SET_ANSWERS_MAP: {
      return {
        ...state,
        answersMap: { ...payload },
      };
    }
    case ACTION_TYPES.SET_SELECTED_PLACEHOLDER:
      return {
        ...state,
        selectedPlaceholder: payload.key,
        selectedSectionIndex: payload.index,
      };
    case ACTION_TYPES.ENABLE_USER_RESPONSES:
      return {
        ...state,
        isUserSelectionEnabled: true,
      };
    case ACTION_TYPES.DISABLE_USER_RESPONSES:
      return {
        ...state,
        isUserSelectionEnabled: false,
      };
    case ACTION_TYPES.START_STANDARD_MODE:
      return {
        ...initialState,
        isOnboarding: false,
        firstPlaceholder: state.firstPlaceholder,
      };
    default:
      return state;
  }
};

export default sessionReducer;
